export default __webpack_public_path__ + "static/media/hungerformore.cd87a996.png";